import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext, useEffect, useMemo, useState } from "react"
import { AppContext } from "Views/Home/context"
import OperationPerson from "./WeChatTool/OperationPerson"
import { CalendarContext } from "./context"
import moment from "moment"
import { useOldTable as useTable } from "Hooks/table"
import { generateDateRange } from "Methods/date"
import { tableInitialVariables } from "Methods/table"
import { generateMutation, generateQuery } from "Methods/query"

const useStyle = makeStyles(() => ({
    header: {
        display: "flex",
        width: "100%",
    },
    label: {
        width : "130px",
        padding: "2px 4px",
    },
    content: {
        borderLeft: "1px solid #ddd",
        display: "flex",
        flexGrow: 1,
        FlexDirection: "column",
    },
    timeLabel: {
        width: "100%",
        textAlign: "center",
        fontWeight: "bold",
    },
    timeLabelPos: {
        width: 200,
        flexShrink: 0,
        textAlign: "center",
        fontSize: 18,
    },
    input: {
        display: "flex",
        width: "100%",
        marginTop: 10,
        height: 35,
        paddingLeft: 4,
        borderTop: "1px solid #ddd",
        alignItems: "center",
        justifyContent: "center",
        "& span": {
            whiteSpace: "nowrap",
        },
    },
}))
const value = "op_person_schedule"
const Calendar = () => {
    const classes = useStyle()
    const { currentDate, isWeChat, isWeibo, isSpecies, isHealth, places, channelName } = useContext(CalendarContext)
    const { user } = useContext(AppContext)
    const [ channelId, setChannelId ] = useState(0)
    const { role } = user || {}
    const { role_name } = role || {}
    const isTrueEditor = role_name === "true_editor"
    const isSideEditor = role_name === "side_editor"
    const isOpEditor = role_name === "op_editor"
    const dateRange = useMemo(() => {
        return generateDateRange(currentDate)
    }, [currentDate])
    const initVariables = {
        ...tableInitialVariables,
        limit: 1000,
        where: {
            op_time: {
                _gte: dateRange[0],
                _lte: dateRange[dateRange.length - 1],
            },
        },
    }
    const { data, onRowAdd, onRowUpdate, setVariables } = useTable({
        tableName: value,
        initVariables,
        getQuery: generateQuery(value),
        addMutation: generateMutation("insert", value, [
            {name: "op_person_id", type: "Int"},
            {name: "channel_id", type: "Int"},
            {name: "op_time", type: "timestamptz"},
        ]),
        updateMutation: generateMutation("update", value, [
            { name: "op_person_id", type: "Int"},
            { name: "channel_id", type: "Int"},
            { name: "id", type: "Int"},
        ]),
        delMutation: generateMutation("delete", value, [
            { name: "id", type: "Int"},
        ]),
        field: ["id", "op_person_id", "op_time", "channel_id"],
    })
    useEffect(() => {
        if (places.length) {
            setChannelId(Number(places[0].channel_id))
        }
    }, [places])
    useEffect(() => {
        if (channelId) {
            setVariables({
                ...tableInitialVariables,
                limit: 1000,
                where: {
                    op_time: {
                        _gte: dateRange[0],
                        _lte: dateRange[dateRange.length - 1],
                    },
                    channel_id: {
                        _eq: channelId,
                    },
                },
            })
        }
        // eslint-disable-next-line
    }, [currentDate, channelId])
    const dataMap = useMemo(() => {
        return data && data.reduce((acc: any, cur: any) => {
            acc[new Date(cur.op_time).getTime()] = cur
            return acc
        }, {})
    }, [data])
    return (
        <div className={classes.header}>
            <div className={classes.label}></div>
            <div className={classes.content}>
                {
                    dateRange.map((d: Date) => (
                        <div key={d.getTime()} className={classes.timeLabel}>
                            <div>{moment(d).format("DD dddd")}&nbsp;&nbsp;</div>
                            { isWeChat || isWeibo || isSpecies || isHealth ? (
                                <div className={classes.input}>
                                    <span>值班:</span>
                                    <OperationPerson
                                        opPerson={dataMap[d.getTime()]}
                                        tableName={isHealth ? 'health_operation_person' : "operation_person"}
                                        isSpecies={isSpecies}
                                        onChange={(value) => {
                                            if (dataMap[d.getTime()]) {
                                                onRowUpdate({
                                                    op_person_id: Number(value),
                                                    id: dataMap[d.getTime()].id,
                                                    channel_id: channelId,
                                                })
                                            } else {
                                                onRowAdd({
                                                    op_person_id: Number(value),
                                                    op_time: d,
                                                    channel_id: channelId,
                                                })
                                            }
                                        }}/>
                                </div>
                            ) : null }
                        </div>
                    ))
                }
                { (((isTrueEditor || isSideEditor || isOpEditor)
                    && (isWeChat || isWeibo || isSpecies || isHealth))
                    || channelName === '吃货')
                    && <div className={classes.timeLabelPos}>备选列表</div> }
            </div>
        </div>
    )
}

export default Calendar
